import React, { useState } from 'react'
import { app, use, api } from 'xadmin'
import { Model } from 'xadmin-model'
import { ModelBlock } from 'xadmin-model'
import { Icon, Page, C } from 'xadmin-ui'
import { Button, Tabs, Popconfirm, Modal, message } from 'antd'
import _ from 'lodash'
import { PlusOutlined, UserOutlined, CheckCircleOutlined, CloseCircleOutlined, EyeOutlined, EditOutlined,DeleteOutlined } from '@ant-design/icons'
import { HasPermission } from 'xadmin-auth'
import { isPermission, deleteUserItem } from './../models'
// const isPermission = (user, view) => {
//   return user.permissions.indexOf(view)
// }

// const deleteItem = (newSchema, userForm, field) => {
//   delete newSchema.properties[field]
//   userForm.forEach((val, index) => {
//     if(val == field) userForm.splice(index, 1)
//     if(val?.key == field) userForm.splice(index, 1)
//   })
//   return newSchema
// }

const BackupBtn = props => {
  const { setData } = props
  const { modelDispatch } = use('model')
  const { selected } = use('model.select')
  const disabled = selected && !_.isEmpty(selected)

  const onClick = () => {
    if (disabled) {
      Promise.all(selected.map(item => {
        return api({ name: `core/user/restore/${item?.id}` }).fetch('', { method: 'PATCH', body: JSON.stringify({}) })
          .then(({ json }) => json)
      })).then((result) => {
        message.success('恢复成功!')
        modelDispatch({ type: 'SELECT_CLEAR' })
        modelDispatch({ type: 'GET_ITEMS', wheres: { filters: { backupStatus: { '$in': [ 'edit', 'delete' ] } } } })
      })
    }
  }
  return <div>
    <Button {...props} onClick={onClick} disabled={!disabled}>恢复</Button>
    <Button {...props} style={{ marginLeft: '1rem' }} onClick={() => setData({ visible: false }) }>取消</Button>
  </div>
}

const UserBackup = props => {
  const [ data, setData ] = React.useState({ visible: false })
  const { settings } = use('settings')
  const needBackup = settings?.userExpand?.needBackup

  let userSchema = app.get('models')['User']

  userSchema = {
    ...userSchema,
    name: '数据恢复',
    resource: 'core/user/backup',
    properties: {
      ...userSchema?.properties,
      backupStatus: {
        title: '修改状态',
        type: 'string',
        enum: [ 'edit', 'delete' ],
        enum_title: [ '被修改', '被删除' ]
      }
    },
    itemActions: [],
    formProps: {},
    components: {
      DataEmpty: props => <C is="NoData" />
    },
    form: [ 'name', 'phone', 'email','status', 'backupStatus' ],
    listFields: [ 'name', 'phone', 'email','status', 'backupStatus' ],
    projectFields: [ 'name', 'phone', 'email','status', 'backupStatus' ],
    initialValues: { wheres: { filter: { backupStatus: { '$in': [ 'edit', 'delete' ] } } } }
  }

  if(!needBackup) return null
  return <>
    <Button type="primary" onClick={() => setData({ ...data, visible: true })}>数据恢复</Button>
    <Modal title="数据恢复" width={"80%"} footer={null} visible={data?.visible} okText="恢复"
     onCancel={() => setData({ visible: false })}
    >
      <Model schema={userSchema} modelKey="userBackup">
        <div><C is="Model.DataTable" /></div>
        <div key="model-list-downnav" style={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
          <C is="Model.Pagination" />
        </div>
        <div key="model-list-downnav" style={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
          <BackupBtn data={data} setData={setData}/>
        </div>
      </Model>
      
    </Modal>
  </>

}

const UserView = props => {
  const { model, getModelState, selected, modelState, modelDispatch } = use('model', props, state => ({ selected: state.filter.fields }))
  const { items } = use('model.list')
  const { user } = use('redux', state => ({ user: state.user }))
  const userSchema = app.get('models').User
  const { settings } = use('settings')
  const needExamine = settings?.userExpand?.needExamine
  const needLogout = settings?.userExpand?.needLogout
  const needBackup = settings?.userExpand?.needBackup
  let newSchema = _.cloneDeep(userSchema)
  const key = window.location.hash.split("?")[1]
  const permissions = user?.permissions
  const isSuper = user?.isSuper
  React.useEffect(() => {
    changeSchema(key)
  }, [JSON.stringify(items)])

  if (!user?.isSuper) {
    if (user.permissions?.length) {
      let nodePermission = isPermission(user, 'node.view')
      let departPermission = isPermission(user, 'department.view')
      let rolePermission = isPermission(user, 'role.view')
      if (userSchema && departPermission == -1) deleteUserItem(newSchema, newSchema.form, 'department')
      if (userSchema && nodePermission == -1) deleteUserItem(newSchema, newSchema.form, 'node')
      if (userSchema && rolePermission == -1) deleteUserItem(newSchema, newSchema.form, 'roles')
    }
  }

  const allSchema = use('auth.userExpand', { newSchema })
  const [schema, setSchema] = React.useState(allSchema)
  let status = []
  if (isSuper ? needExamine && needLogout : needExamine && _.includes(permissions, 'user.examine') && needLogout) {
    status = [{ key: '', value: '全部用户' }, { key: 'active', value: '有效用户' }, { key: 'close', value: '注销用户' }, { key: 'exame', value: '审核用户' }]
  } else if (needLogout) {
    status = [{ key: '', value: '全部用户' }, { key: 'active', value: '有效用户' }, { key: 'close', value: '注销用户' }]
  } else if (isSuper ? needExamine : needExamine && _.includes(permissions, 'user.examine')) {
    status = [{ key: '', value: '全部用户' }, { key: 'active', value: '有效用户' }, { key: 'exame', value: '审核用户' }]
  }

  const filter = getModelState().filter

  let fields = [].concat(filter.fields || [])

  const changeSchema = (tab) => {
    const wheres = getModelState().wheres
    const filters = _.omit(wheres.filters, ['status', 'or', 'examineStatus'])
    const status = tab == 'active' ? { or: [{ status: {  in: ['active', 'sleep']} }, { disabled: { in: [false, null] }, examineStatus: null }] } : {status: tab}
    const newWheres = tab === 'exame' ? { examineStatus: { in: ['examine', 'nopass'] } } : tab ? status : {}
    if (tab == 'exame') {
      schema.properties = _.mapValues(schema.properties, item => item.exame ? _.omit(item, 'showInList') : item)
      schema.listFields = [...schema.listFields, 'examineStatus', 'examineType']
      fields = _.uniq([...fields, 'examineStatus', 'examineType'])
      const itemActions = [
        ({ item }) => {
          const { deleteItem } = use('model.delete', item)
          const { saveItem } = use('model.save', { successMessage:false })
          const examineType = item?.examineType
          const examineStatus = item?.examineStatus
          const id = item?.id
          const onConfirm = () => {
            if (examineType == 'delete') {
              saveItem({ examineStatus: 'pass', id: item.id })
              deleteItem()
            }  else if (examineType == 'add' || examineType == 'edit') {
              saveItem({ examineStatus: 'pass', id: item.id })
            } 
            message.success( '审核通过！')
          }
          const onReject = () => {
            saveItem({examineStatus: 'nopass', id: item.id}).then(( )=>{
              message.success( '已拒绝申请！')
            })
          }
          const onDelete = () => {
            saveItem({examineStatus: 'cancel', id: item.id}).then(( )=>{
              message.success( '删除成功！')
              window.location.reload()
            })
          }

          return (
            examineStatus == 'examine' ? (
              <div>
                <Button onClick={() => app.go(`/app/model/User/${item.id}/detail`)}><EyeOutlined /><span>查看</span></Button>
                <HasPermission permission="user.examine">
                <Button onClick={onConfirm}><CheckCircleOutlined /><span>通过</span></Button>
                <Button onClick={onReject}><CloseCircleOutlined /><span>拒绝</span></Button>
                </HasPermission>
          
              </div>
            ) : (examineStatus == 'nopass' && examineType == 'add' ? (
              <div>
                <Button onClick={() => app.go(`/app/model/User/${item.id}/edit`)}><EyeOutlined /><span>编辑</span></Button>
                <Button onClick={onDelete}><CloseCircleOutlined /><span>删除</span></Button>
              </div>
            ) :(
              <div>
                <Button onClick={() => app.go(`/app/model/User/${item.id}/detail`)}><EyeOutlined /><span>查看</span></Button>
                <Button onClick={onDelete}><CloseCircleOutlined /><span>删除</span></Button>
              </div>
            )
            )
          )
        }
      ]
      schema.itemActions = itemActions
      setSchema(_.cloneDeep(schema))
    } else if (tab == 'close'){
      schema.itemActions = [
        ({ item }) => { 
          const id = item.id
          const { deleteItem } = use('model.delete', item)
          const onDelete = () => {
            api({ name: 'core/user' }).fetch(`/${id}`, {
              method: 'DELETE'
            }).then((res) => {
              message.success('提交审核成功，请耐心等待审核结果！')
            }
            )
          }
           return  <Button onClick={onDelete} style={{ background: 'red', color: '#fff' }}><DeleteOutlined /></Button>
        }
      ]
      setSchema(_.cloneDeep(schema))
    } else{
      fields = _.difference(fields, ['examineStatus', 'examineType'])
      setSchema(allSchema)
    }
    modelDispatch({ type: 'GET_ITEMS', filter: { ...filter, fields }, wheres: { ...wheres, init_filters: newWheres, filters: { ...filters, ...newWheres} } })
  }

  const onTabChange = tab => {
    changeSchema(tab)
    app.go(`/app/model/User/list?${tab}`)
  }

  return (
    <Model schema={schema} modelKey='user' >
      <Page title={(<span><UserOutlined /> {model?.title}</span>)}
        sider={<ModelBlock name="model.list.sidemenu" />}
        subTitle={<ModelBlock name="model.list.nav" />}
        actions={
          <>
            <UserBackup />
            <HasPermission permission="user.add">
              <Button type="primary" onClick={() => app.go('/app/model/user/add')}><PlusOutlined />添加用户</Button>
            </HasPermission>
          </>
        }
      >
        <ModelBlock name="model.list.submenu" />
        <Tabs activeKey={key} onChange={onTabChange} >
          {status?.map(s => <Tabs.TabPane key={s.key} tab={s.value}></Tabs.TabPane>)}
        </Tabs>
        <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
          <C is="Model.Pagination" /> <C is="Model.ListSubMenu" />
        </div>
        <div className="logTable"><C is="Model.DataTable" /></div>
        <div key="model-list-downnav" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.5rem' }}>
          <C is="Model.ActionBar" />
          <C is="Model.Pagination" />
        </div>
      </Page>
    </Model>
  )
}

export default UserView